<template>
  <div>
    <BreadCrumb
      v-if="breadcrumbRoutes.length && showBreadCrumb"
      :routes="breadcrumbRoutes"
    />
    <slot />
  </div>
</template>

<script>
import BreadCrumb from '@/layout/Breadcrumb.vue'
export default {
  name: 'PageHeaderWrapper',
  components: {
    BreadCrumb
  },
  props: {
    showBreadCrumb: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      breadcrumbRoutes: []
    }
  },
  created () {
    const routes = this.$route.matched.concat().map((route) => {
      return {
        path: route.path,
        breadcrumbName: route.meta.title
      }
    })
    this.breadcrumbRoutes = routes.filter(item => {
      return item.breadcrumbName !== undefined
    })
  }
}
</script>
